export const LOAD_PROJECTS = "LOAD_PROJECTS"
export const loadProjectsAction = projects => ({
   type: LOAD_PROJECTS,
   payload: projects
})